<template>
    <div class="media-category-list">
        <Row>
            <Col :xs="24" :sm="24">
                <Form :inline="true">
                    <FormItem>
                        <Input v-model="search.category_name" placeholder="请输入分类名称" clearable></Input>
                    </FormItem>
                    <FormItem>
                        <Button @click="renderTable()" type="primary">搜索</Button>
                    </FormItem>
                    <FormItem>
                        <Button @click="showDraw()" type="success" class="f-r">添加</Button>
                    </FormItem>
                </Form>
            </Col>
        </Row>
        <Table border :columns="columns" ref="selection" :data="tablelist" :loading="dataloading"></Table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page
                        ref="listPage"
                        :total="pages.total"
                        :current="pages.page"
                        :page-size="pages.size"
                        show-elevator
                        show-total
                        @on-change="changePage()"
                ></Page>
            </div>
        </div>
        <!-- 添加的弹出 -->
        <Drawer
                :title="title"
                v-model="showDrawStatus"
                width="500"
                :mask-closable="false"
                :styles="styles"
        >
            <Form :model="categoryForm" ref="categoryValidate" :rules="categoryValidate">
                <FormItem label="分类名称" label-position="top" prop="category_name">
                    <Input v-model="categoryForm.category_name"></Input>
                </FormItem>
            </Form>
            <div class="demo-drawer-footer">
                <Button style="margin-right: 8px" @click="hideDraw">取消</Button>
                <Button type="primary" @click="save('categoryValidate')">提交</Button>
            </div>
        </Drawer>
    </div>
</template>

<script>
    export default {
        name: "media-category-list",
        data() {
            return {
                title: "添加",
                loading: true,
                dataloading: true,
                styles: {
                    height: "calc(100% - 55px)",
                    overflow: "auto",
                    paddingBottom: "53px",
                    position: "static"
                },
                columns: [
                    {
                        title: "Id",
                        key: "id",
                        minWidth: 100
                    },
                    {
                        title: "分类名称",
                        key: "category_name",
                        minWidth: 200
                    },
                    {
                        title: "添加时间",
                        key: "created_at",
                        minWidth: 200
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "left",
                        width: 200,
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        style: {
                                            marginRight: "8px"
                                        },
                                        props: {
                                            type: "primary",
                                            size: "small"
                                        },
                                        on: {
                                            click: () => {
                                                this.detail(params.row.id);
                                            }
                                        }
                                    },
                                    "编辑"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small"
                                        },
                                        on: {
                                            click: () => {
                                                this.remove(params.row.id);
                                            }
                                        }
                                    },
                                    "删除"
                                )
                            ]);
                        }
                    }
                ],
                tablelist: [],
                search: {
                    category_name: "",
                },
                pages: {
                    page: 1,
                    size: 10,
                    total: 0
                },
                showDrawStatus: false,
                categoryValidate: {
                    category_name: [{required: true, message: "分类名称必须填写", trigger: "blur"}],
                },
                categoryForm: {
                    id: 0,
                    category_name: '',
                },
            };
        },
        // 计算
        computed: {},
        // 监听
        watch: {},
        created: function () {
            // 取数据
            this.getTableList();
        },
        methods: {
            hideDraw() {
                this.categoryForm = {
                    id: 0,
                    category_name: '',
                };
                this.showDrawStatus = !this.showDrawStatus;
            },
            getTableList: function () {
                var ps = {
                    category_name: this.search.category_name,
                    page: this.pages.page,
                    size: this.pages.size
                };
                this.$api.mediaCategory.list(ps).then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        this.tablelist = res.result.list;
                        this.pages.total = res.result.total;
                        this.$Message.success(res.msg);
                    }
                });
                return;
            },
            // 展开添加
            showDraw() {
                this.categoryForm = {
                    id: 0,
                    category_name: '',
                };
                this.title = "添加";
                this.showDrawStatus = !this.showDrawStatus;
            },
            // 详情
            detail(id) {
                this.title = "修改";
                this.showDrawStatus = !this.showDrawStatus;
                this.$api.mediaCategory.detail({id: id}).then(res => {
                    if (res.code == 200) {
                        this.categoryForm = {
                            id: res.result.detail.id,
                            category_name: res.result.detail.category_name,
                        };
                    }
                });
            },
            // 添加
            save(name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        let ps = {
                            category_name: this.categoryForm.category_name,
                        }
                        if (this.categoryForm.id > 0) {
                            ps.id = this.categoryForm.id;
                            this.$api.mediaCategory.edit(ps).then(res => {
                                if (res.code == 200) {
                                    this.$Message.success(res.msg);
                                    this.showDrawStatus = !this.showDrawStatus;
                                    this.renderTable();
                                }
                            });
                        } else {
                            this.$api.mediaCategory.create(ps).then(res => {
                                if (res.code == 200) {
                                    this.$Message.success(res.msg);
                                    this.showDrawStatus = !this.showDrawStatus;
                                    this.renderTable();
                                }
                            });
                        }
                    } else {
                        this.$Message.error("请检查输入的信息是否正确！");
                    }
                });
            },
            remove: function (index) {
                // 弹出确认框
                this.$Modal.confirm({
                    title: "警告",
                    content: "<p>此操作不可恢复，三思而后行...</p>",
                    onOk: () => {
                        this.$api.mediaCategory.remove({id: index}).then(res => {
                            if (res.code == 200) {
                                this.$Message.success(res.msg);
                                this.renderTable();
                            }
                        });
                    }
                });
            },
            // 翻页
            changePage() {
                this.pages.page = this.$refs["listPage"].currentPage;
                this.getTableList();
            },
            // 筛选
            renderTable: function () {
                this.pages.page = 1;
                this.getTableList();
            },
        }
    };
</script>
<style>
    .demo-drawer-footer {
        width: 100%;
        height: 50px;
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: 1px solid #e8e8e8;
        padding: 10px 16px;
        text-align: right;
        background: #fff;
    }
</style>
